<template>
    <div class="board" :class="{ 'board--dragging' : isDragging }">
        <div class="board__inner">
            <swiper v-if="isMobile" :options="swiperOption">
                <swiper-slide :key="column.id" v-for="column in columns">
                    <column ref="column"
                            class="lc-column-item"
                            :column="column"/>
                </swiper-slide>
                <swiper-slide>
                    <create-column />
                </swiper-slide>
                <div class="swiper-pagination board__swiper-pagination" slot="pagination"></div>
            </swiper>
            <draggable v-else
                       ref="columns"
                       v-model="columns"
                       @change="onColumnRepositioned"
                       class="board__draggable"
                       ghost-class="column--ghost"
                       chosen-class="column--chosen"
                       handle=".js-column-handle">
                <column v-for="column in columns"
                        ref="column"
                        :key="column.id"
                        class="lc-column-item"
                        :column="column"
                        @start-dragging="isDragging = true"
                        @stopped-dragging="isDragging = false" />
            </draggable>
            <create-column v-if="isMobile === false" />
        </div>

        <div class="board__footer">
            <button v-if="columns.length > 0" @click="createJob" class="action">
                <icon type="plus" color="white" size="24" />
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Draggable from 'vuedraggable'
import Column from './Column'
import Icon from '../Global/Icon'
import CreateColumn from './CreateColumn'
import Device from '../../mixins/deviceAware'
import calculatePosition from '../../mixins/calculatePosition'
import dragHorizontally from '../../mixins/dragHorizontally'
import { OPEN_JOB_CREATION } from '../../stores/global/mutations'
// require styles
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    mixins: [calculatePosition, dragHorizontally, Device],

    data () {
        return {
            isDragging: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true
                }
            }
        }
    },

    methods: {
        ...mapMutations({
            createJob: OPEN_JOB_CREATION
        }),

        onColumnRepositioned ({ moved, added, removed }) {
            if (added || removed) {
                return
            }

            let position = this.calculatePositionWhenMoved(this.columns, moved.newIndex, moved.oldIndex)

            let data = {
                id: moved.element.id,
                position: position
            }

            this.$store.dispatch('channel/repositionColumn', data).then((response) => {
                if (response.data.position < 1 || response.data.position > 1000000) {
                    this.$store.dispatch('channel/repositionAllColumns')
                }
            })
        }
    },

    computed: {
        ...mapState('channel', ['channel']),

        columns: {
            get () {
                return this.$store.getters['channel/columns']
            },
            set (sortedColumns) {
                // Do nothing
            }
        }
    },

    components: {
        CreateColumn,
        Column,
        Draggable,
        Icon,
        swiper,
        swiperSlide
    }
}
</script>
